// extracted by mini-css-extract-plugin
export default {"hideTooltip":"D9-z","fadeIn":"E9-z","delay":"F9-z","recommendedSizeTooltip":"G9-z"};